module.exports = __webpack_public_path__ + "img/187.problem_coffee_machine.c89e26b2.svg";